// extracted by mini-css-extract-plugin
export default {"capaV2":"styles_capaV2__fGsgb"};